import { Controller, useForm } from "react-hook-form";
import { Popup } from "@/components/popups/Popup";
import { ToggleButton } from "@/components/buttons/ToggleButton";
import { ICollection, ICreateCollection } from "@/common/services/types";
import { TextInput } from "@/components/inputs/TextInput/TextInput";
import { TextArea } from "@/components/inputs/TextArea/TextArea";
import { showNotification } from "@/components/notifications/Notifications";
import { apiCollections } from "@/common/services";

import "./CreateNewCollectionPopup.scss";
import { onCloseCreateNewCollectionPopup } from "@/components/popup-dispatcher/PopupDispatcher";

interface ICreateNewCollectionPopupProps {
  onCreated: (collection: ICollection) => void;
}

interface IForm {
  published: boolean;
  description: string;
  folderName: string;
}

export const CreateNewCollectionPopup = ({ onCreated }: ICreateNewCollectionPopupProps) => {
  const { control, handleSubmit, formState } = useForm<IForm>();

  const onSubmit = async (data: IForm) => {
    const dataToSend: ICreateCollection = {
      published: !data.published,
      description: data.description || null,
      folderName: data.folderName
    };

    try {
      const collection = await apiCollections.createCollection(dataToSend);
      onCreated(collection);
      showNotification({
        variant: "success",
        title: "Successfully created."
      });
    } catch (e) {
      showNotification({
        variant: "error",
        title: "Something went wrong. Please try later."
      });
    } finally {
      onCloseCreateNewCollectionPopup();
    }
  };

  const btnProps = {
    variant: 1,
    title: "Create a Collection",
    formId: "create-collection-form",
    btnType: "submit",
    disabled: formState.isSubmitting
  };

  return (
    <Popup
      isOpen={true}
      onClose={onCloseCreateNewCollectionPopup}
      title="Create a Collection"
      popupClass="CreateNewCollectionPopup"
      btnProps={btnProps}
    >
      <form onSubmit={handleSubmit(onSubmit)} id="create-collection-form">
        <Controller
          name="folderName"
          control={control}
          defaultValue=""
          rules={{ required: "Required Field!" }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextInput
              label="Collection name"
              onChange={onChange}
              value={value}
              error={error?.message}
              disabled={formState.isSubmitting}
            />
          )}
        />

        <Controller
          name="description"
          control={control}
          defaultValue=""
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextArea label="Description" onChange={onChange} value={value} rows={3} error={error?.message}/>
          )}
        />

        <div className="CreateNewCollectionPopup-Toggle">
          <p>Make private</p>
          <Controller
            name="published"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value } }) => (
              <ToggleButton checked={value} onChange={onChange}/>
            )}
          />
        </div>
      </form>
    </Popup>
  );
};

